module.exports = "<p>\n  functional-category-rate-pools works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional-category-rate-pools/functional-category-rate-pools.component.html
// module id = ./src/app/functional-category-rate-pools/functional-category-rate-pools.component.html
// module chunks = main